export enum ConnectedAccountStatus {
    Pending = 'pending',
    Initiated = 'initiated',
    Submitted = 'submitted',
    Active = 'active',
    Suspended = 'suspended',
    ActionRequired = 'action-required',
    Disabled = 'disabled',
}
